import { render, staticRenderFns } from "./productPricing.vue?vue&type=template&id=5ec3f4d2&scoped=true"
import script from "./productPricing.vue?vue&type=script&lang=js"
export * from "./productPricing.vue?vue&type=script&lang=js"
import style0 from "./productPricing.vue?vue&type=style&index=0&id=5ec3f4d2&prod&scoped=true&lang=scss"
import style1 from "./productPricing.vue?vue&type=style&index=1&id=5ec3f4d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec3f4d2",
  null
  
)

export default component.exports